"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedbackSyncIntegration = void 0;

var _feedback = require("@sentry-internal/feedback");

/** Add a widget to capture user feedback to your application. */
const feedbackSyncIntegration = exports.feedbackSyncIntegration = (0, _feedback.buildFeedbackIntegration)({
  getModalIntegration: () => _feedback.feedbackModalIntegration,
  getScreenshotIntegration: () => _feedback.feedbackScreenshotIntegration
});